/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { useRecoilState } from 'recoil';
import Select, { CssTextField } from 'components/select';
import InfoImg from 'pages/provisioning/_components/InfoImg';
import { toggleCreateLandingZone, landingZoneForm } from 'pages/app-profiles/store';

const PrivateDnsZone = ({ index }) => {
    const [lzModal] = useRecoilState(toggleCreateLandingZone);
    const [landZoneForm, setLandingZoneForm] = useRecoilState(landingZoneForm);
    const [options, setOptions] = React.useState([]);

    const setPrivateDnsZone = (privateDnsZone = null) => {
        const form = { ...landZoneForm };
        try {
            const result = form.privateEndPoints.map((item, i) => {
                let obj = { ...item };
                if (index === i) {
                    obj = { ...obj, privateDnsZone: privateDnsZone !== '' || privateDnsZone !== null ? privateDnsZone : null };
                }
                return obj;
            });
            form.privateEndPoints = result;
        } catch (e) {
            // eslint-disable-next-line
            console.log(e);
        }
        setLandingZoneForm(form);
    };

    const seldValueExistsInOptions = (value) => options.find((option) => value === option?.label);

    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.label)) {
            setPrivateDnsZone(selected?.label);
        } else {
            setPrivateDnsZone();
        }
    };

    React.useEffect(() => {
        if (options?.length && options?.length > 0 && lzModal?.lzDetails) {
            const privateDnsZone = options.find((value) => lzModal?.lzDetails?.config?.privateEndPoints[index]?.privateDnsZone === value?.label);
            if (privateDnsZone) setPrivateDnsZone(privateDnsZone?.label);
        }
        if (options?.length && options?.length === 1) {
            handleOnSelectChange(options[0]);
        }
    }, [options]);

    React.useEffect(() => {
        setOptions([
            { label: 'privatelink.blob.core.windows.net', value: 'privatelink.blob.core.windows.net' },
            { label: 'pep.blob.core.windows.net', value: 'pep.blob.core.windows.net' },
        ]);
    }, []);

    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                <Select
                    key="privateDnsZone"
                    value={landZoneForm?.privateEndPoints?.[index]?.privateDnsZone}
                    options={options}
                    handleOnSelect={(value) => handleOnSelectChange(value)}
                    disableClearable={false}
                    renderInput={(params) => (
                        <CssTextField
                            {...params}
                            label="Private DNS Zone"
                            placeholder="Private DNS Zone"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: <>{params.InputProps.endAdornment}</>,
                            }}
                        />
                    )}
                />
                <InfoImg title="Type  Endpoint Name" />
            </Stack>
        </>
    );
};
PrivateDnsZone.propTypes = {
    index: PropTypes.number,
};

PrivateDnsZone.defaultProps = {
    index: 0,
};

export default React.memo(PrivateDnsZone);
